import { createSelector } from 'reselect';
import { AppState } from '../store/types/Store';

export const getRegionData = (state: AppState) => state.region;

export const getRegionReport = createSelector([
    getRegionData
], (regionData) => regionData.reportData ?? null);

export const getRegionIsLoading = createSelector([
    getRegionData
], (regionData) => regionData.isLoadingReport ?? true);

export const getRegionIsValid = createSelector([
    getRegionData
], (regionData) => regionData.isRegionValid);

export const getIsValidatingRegion = createSelector([
    getRegionData
], (regionData) => regionData.isValidatingRegion);